import { render } from "./PaginationControls.vue?vue&type=template&id=2b724bca&scoped=true"
import script from "./PaginationControls.vue?vue&type=script&lang=js"
export * from "./PaginationControls.vue?vue&type=script&lang=js"

import "./PaginationControls.vue?vue&type=style&index=0&id=2b724bca&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b724bca"],['__file',"resources/js/components/PaginationControls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b724bca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b724bca', __exports__)) {
    api.reload('2b724bca', __exports__)
  }
  
  module.hot.accept("./PaginationControls.vue?vue&type=template&id=2b724bca&scoped=true", () => {
    api.rerender('2b724bca', render)
  })

}


export default __exports__